<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-style: italic; font-size: 1.17em;">Some guys have all the luck.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Chris?” Jase regarded him with amusement. “You got enough shots in this position? Only, I’m gonna get cramps in my legs any second now.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“I’ll rub ’em for ya,” Gabe volunteered, slipping his hand under the sheets, but Jase stopped the motion with his own hand, grasping Gabe’s wrist firmly.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“That’s quite all right. I’m more than capable of doing that myself.” He glanced toward Chris with an eye roll that Gabe wouldn’t catch.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Chris felt a little lighter. “Okay, guys, I think that’s enough. We’ve got plenty of the steamier poses in case the publisher wants to try and slip one past Amazon again.” <span style=" font-style: italic; font-size: 1.00em;">And good luck with that.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?5fccdf5d